
<template>
  <div class="seckill-component" >
    <div class="squre f-l">{{nowTime.h}}</div>
    <div class="text f-l">时</div>
    <div class="squre f-l">{{nowTime.m}}</div>
    <div class="text f-l">分</div>
    <div class="squre f-l">{{nowTime.s}}</div>
    <div  class="text f-l">秒</div>
    <!--<b class="squre" ></b><span class="text"></span><b class="squre"></b><span class="text"></span><b class="squre"></b><span class="text"></span>-->
  </div>
</template>

<script >
import TimerManager from '@/utils/timer'
export default {
    name: 'seckill',
    props: {
        timestamp: { // 活动的图片
            required: true,
            type: String,
            default: '0'
        },
    },
    watch: {
        // timestamp (newTime) {
        //     alert(newTime)
        // }
    },
    methods: {
        start (timestamp = this.timestamp) {
            this.timerManager = TimerManager.getInstance()
            this.timerManager.start(Number(timestamp), (status, data) => {
                if (status === 1) {
                    this.$emit('success')
                }
                if (data) {
                    this.$nextTick(() => {
                        this.nowTime = data
                    })
                }
            })
        }
    },
    data () {
        return {
            timerManager: '',
            nowTime: ''
        }
    },
    created () {
        this.start()
    },
    destroyed () {
        this.timerManager.end()
    }
}
</script>

<style lang="stylus" scoped>
@import "../../assets/stylus/variables";

.seckill-component
    width 100%
    display flex
    align-items center
    .squre
        min-width 38px
        height 38px
        border-radius 10px
        background-color #fc2d2d
        color white
        text-align center
        line-height 38px
    .text
        margin-left 5px
        margin-right 5px
    .f-l
        float left
</style>
